import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import {
  IOptionSets,
  IOptions,
  IEngineer,
  IContact,
  IContactInput,
  LicensedDesignProfessionalGqlService,
  AppLoadService,
  RecaptchaService
} from '@ebb-v2/ebb-integration';
import {
  OptionSetsApiService,
  LicensevalidationService
} from '../../../../../../data-services/index';

import { spaceValidator } from '../../../../../../_helpers/spaceValidator';
import { MatStepper } from '@angular/material/stepper';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { elementAt } from 'rxjs/operators';
import { RecaptchaComponent } from 'ng-recaptcha';


@Component({
  selector: 'eng-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {
  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;
  public enginnerInput: any;
  public stepSection = 1;
  ldpInput: FormGroup;
  ldpinfo: FormGroup;
  ldpaddressinfo: FormGroup;
  contactOptions: IOptionSets[] = [];
  licenseTypeOptions: IOptions[] = [];
  hearaboutustypes: IOptions[] = [];
  IContactInput: IContactInput = {} as IContactInput;
  ldplicenseinfo: any;
  ldpcontact: IContact;
  ldpshowerror: boolean;
  ldperrormessage: string;
  ldplicensenumber: string;
  ldplicensetype: string;
  ldplicenseexpdate: Date;
  ldpType: string;
  ldpfullname: string;
  public message = '';
  public formAutoSave = false;
  public ischecked = false;
  public recaptchaEnabled = false;
  public siteKey: string = '';
  public recaptchaToken ='';
  constructor(
    private _fb: FormBuilder,
    private apiOptionSets: OptionSetsApiService,
    private apiLicenseValidation: LicensevalidationService,
    private apiContact: LicensedDesignProfessionalGqlService,
    private appLoadService: AppLoadService,
    private recaptchaService: RecaptchaService,
  ) {}

  ngOnInit(): void {
    this.recaptchaEnabled = this.appLoadService.getRecaptchaEnabled();
    this.siteKey = this.appLoadService.getRecaptchaKey();
    this.ldpInput = this._fb.group({
      licensenumber: ['', Validators.compose([Validators.required, spaceValidator])],
      licensetype: ['', Validators.required],
      recaptchaReactive:['', this.recaptchaEnabled?Validators.required:null],
    });
   
    this.ldpinfo = this._fb.group({
      firstname: [
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(100),
          spaceValidator
        ])
      ],
      lastname: [
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(100),
          spaceValidator
        ])
      ],
      email: [
        null,
        [
          Validators.required,
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
          Validators.maxLength(100)
        ]
      ],

      address: [''],
      suite: [''],
      city: [''],

      zipcode: [''],
      state: [''],
      bname: ['', Validators.maxLength(100)],
      website: [''],
      telephone1: ['', Validators.required],
      telephone1sms: [''],
      hearaboutus: [''],
      hearaboutusOther: ['', spaceValidator],
      confirm1: [null, [Validators.required, Validators.requiredTrue]],
    });
  
    this.loadAppldpOptionsData();
  }
  private loadAppldpOptionsData(): void {
    this.apiOptionSets.getList('contact').subscribe(
      data => {
        this.contactOptions = data;
        const indexeventOptions = this.contactOptions.findIndex(
          i => i.name === 'cea_licensetypeldp'
        );
        this.licenseTypeOptions = [
          ...this.contactOptions[indexeventOptions].options
        ];
        const indexhowdidhear = this.contactOptions.findIndex(
          i => i.name === 'cea_howdidyouhearaboutus'
        );
        this.hearaboutustypes = [
          ...this.contactOptions[indexhowdidhear].options
        ];
      },
      error => console.warn(error)
    );
  }
  public onControlValidators(controlName: string): boolean {
    const retVal =
      this.ldpInput.get(controlName).errors &&
      (this.ldpInput.get(controlName).dirty ||
        this.ldpInput.get(controlName).touched);

    return retVal;
  }

  private loadldpinfo() {
    if (this.ldplicenseinfo) {
      this.ldpinfo.get('firstname').setValue(this.ldplicenseinfo.firstName);
      this.ldpinfo.get('lastname').setValue(this.ldplicenseinfo.lastName);
      this.ldpinfo.get('address').setValue(this.ldplicenseinfo.address1);
      this.ldpinfo.get('city').setValue(this.ldplicenseinfo.city);
      this.ldpinfo.get('state').setValue(this.ldplicenseinfo.state);
      this.ldpinfo.get('zipcode').setValue(this.ldplicenseinfo.zipCode);
     
      this.ldplicensenumber=this.ldplicenseinfo.licenseNumber;
      this.ldplicenseexpdate = this.ldplicenseinfo.expirationDate;
      this.ldplicensetype = this.ldplicenseinfo.licenseTypeDesc;
    }
  }

  public onlicensecheck(stepper: MatStepper) {
    this.ldpshowerror = false;
    this.ldperrormessage = '';
    this.formAutoSave = true;
    
    this.ldplicensenumber = this.ldpInput.get('licensenumber').value;
    const type = this.ldpInput.get('licensetype').value;
    this.ldpType = type;
    let licenseType = 'C';
    
      switch (type)
      {
          case "700000000":
            licenseType = "C";
              break;
          case "700000001":
            licenseType = "S";
              break;
          case "700000002":
            licenseType = "AR";
              break;
      }
      if (this.recaptchaEnabled) {
        if (!this.recaptchaToken) {
    
          this.formAutoSave = false;
          this.ldpshowerror = true;
          this.ldperrormessage = 'Please complete the CAPTCHA before submitting.';
          return;
        }

        this.recaptchaService.verifyRecaptcha(this.recaptchaToken, 'login',this.ldplicensenumber)
          .subscribe((result: any) => {
            if (result.isValid) {
              this.CheckLdpLicense(licenseType, stepper);
            } else {
              this.formAutoSave = false;
              this.ldpshowerror = true;
              this.onCaptchaExpired();
            
            }
          }, error => {
            this.formAutoSave = false;
            this.ldpshowerror = true;
            this.onCaptchaExpired();
            this.ldperrormessage = 'Error verifying reCAPTCHA. Please try again.';
            
          });
      } else {
        // ✅ Without reCAPTCHA
        this.CheckLdpLicense(licenseType, stepper);
      }
    
  }
  private CheckLdpLicense(licenseType: string, stepper: MatStepper) {

this.apiLicenseValidation.getIsLicenseCheckEnable().subscribe(isEnabled => {
 this.processLicenseCheck(isEnabled, licenseType, stepper);

});
  }
  private processLicenseCheck(isEnabled: boolean, licenseType: string, stepper: MatStepper): void {
  if (this.shouldEnableLicenseCheck(isEnabled)) {
    this.handleLicenseCheckEnabled(licenseType, stepper);
  } else {
    this.handleLicenseCheckDisabled(licenseType, stepper);
  }
}

private shouldEnableLicenseCheck(isEnabled: boolean): boolean {
   return isEnabled;
}

private handleLicenseCheckEnabled(licenseType: string, stepper: MatStepper): void {
  this.apiLicenseValidation.getLdpLicense(this.ldplicensenumber, licenseType).subscribe({
    next: data => {
      this.ldplicenseinfo = data;

      if (data.isValid) {
        this.loadldpinfo();
        this.checkLdpContact(stepper);
      } else {
        this.showError(data.errormessage);
      }
    },
    error: err => {
      this.showError('There is a problem in the system, please try again later.', err);
    }
  });
}
private checkLdpContact(stepper: MatStepper): void {
  this.apiContact.checkLdpLicense(this.ldplicensenumber).subscribe({
    next: data => {
      this.ldpcontact = data;
      this.formAutoSave = false;

      if (this.ldpcontact == null) {
        stepper.next();
      } else {
        this.ldpshowerror = true;
        this.ldperrormessage = 'Licensed Design Professional has already been registered.';
        this.onCaptchaExpired();
      }
    },
    error: err => {
      this.showError('There is a problem in the system, please try again later.', err);
    }
  });
}
private showError(message: string, error?: any): void {
  this.ldperrormessage = message;
  this.formAutoSave = false;
  this.ldpshowerror = true;
  if (error) console.warn(error);
  this.onCaptchaExpired();
}
private handleLicenseCheckDisabled(licenseType: string, stepper: MatStepper): void {
  this.ldplicensetype = licenseType;
  this.formAutoSave = false;
  stepper.next();
}
  public onSave(stepper: MatStepper) {
    this.message ='';
    this.formAutoSave = true;
    this.IContactInput.emailAddress1 = this.ldpinfo.get('email').value;
    this.IContactInput.ldpLicenseNumber = this.ldplicensenumber;
    this.IContactInput.ldpLicenseType = this.ldpType.toString();
    if( this.ldplicenseexpdate !== undefined){
    this.IContactInput.ldpLicenseExpiration = this.ldplicenseexpdate;
    this.IContactInput.ldpLicenseIsValid = this.ldplicenseinfo?.isValid;
    this.IContactInput.ldpStatus = this.ldplicenseinfo?.licenseStatus;
    }

    this.IContactInput.firstName = this.ldpinfo.get('firstname').value;
    this.IContactInput.lastName = this.ldpinfo.get('lastname').value;
    this.IContactInput.address2_Line1 = this.ldpinfo.get('address').value;
    this.IContactInput.address2_Line2 = this.ldpinfo.get('suite').value;
    this.IContactInput.address2_City = this.ldpinfo.get('city').value;
    this.IContactInput.address2_StateOrProvince = this.ldpinfo.get('state').value;
    this.IContactInput.address2_PostalCode = this.ldpinfo.get('zipcode').value;
    this.IContactInput.contactType = '700000006';
    this.IContactInput.businessName = this.ldpinfo.get('bname').value;
    this.IContactInput.webSiteUrl = this.ldpinfo.get('website').value;
    this.IContactInput.telephone1 = this.ldpinfo.get('telephone1').value;

    if (this.ldpinfo.get('hearaboutus').value){
     this.IContactInput.howdidyouhearaboutusType = this.ldpinfo.get('hearaboutus').value.toString();}
    if (this.IContactInput.howdidyouhearaboutusType === '700000006') {
        this.IContactInput.howdidyouhearaboutusOther = this.ldpinfo.get('hearaboutusOther').value;
      }
    if (this.ldpinfo.get('telephone1sms').value) {
      this.IContactInput.telephone1sms = this.ldpinfo.get(
        'telephone1sms'
      ).value;
    }
    this.ldpfullname =
      this.IContactInput.firstName + ' ' + this.IContactInput.lastName;
    if (this.IContactInput.emailAddress1) {
      this.apiContact
      .CheckLdpContactExists(this.IContactInput.emailAddress1)
      .subscribe(
        contact => {
          if (
            contact.isEngineer === true ||
            contact.isHomeowner === true ||
            contact.isContractor === true
          ) {
            this.formAutoSave = false;
            this.message =
              'Email address already in system, please contact EBB Customer Service: Email info@crmp.org Customer Service Number (877) 232-4300.';
            this.ldpinfo.get('email').markAsTouched();
          } else {
            this.apiContact.saveLdpContact(this.IContactInput).subscribe(
              data => {
                if (data) {
                  this.formAutoSave = false;
                  stepper.next();
                }
              },
              error => {
                this.formAutoSave = false;
                this.message = 'There is a problem in the system, please try again later.';
                console.warn(`ERROR: saveLdpContact() - ${error}`);
              }
            );
          }
        },
        error => {
          this.formAutoSave = false;
          this.message = 'There is a problem in the system, please try again later.';
          console.warn(`ERROR: CheckLdpContactExists() - ${error}`);
        }
      );
    
    }
}
public onCaptchaResolved(token: string): void {
  if (this.recaptchaEnabled) {
    this.recaptchaToken = token;
  
  }

}
public onCaptchaExpired(): void {
  this.recaptchaToken = '';
  this.captchaRef?.reset();
  this.ldpInput.get('recaptchaReactive').reset(); // optional: markAsTouched to trigger UI message
  this.ldpInput.get('recaptchaReactive').markAsTouched();
}
  public changeStepSection(direct: number): void {
    this.stepSection += direct;
  }
  oncheckboxChange(ob: MatCheckboxChange) {
    this.ischecked = ob.checked;
  
  }

}
